import React from 'react';

import { Modal, message } from 'antd';
import 'whatwg-fetch';

const headers = {
    'Content-Type': 'application/json',
    'schoolCode': 'public',
};

let errorCount = 0;

//const base = '/education-jxcp-service-web-demo/';
//const base = '/education-jxcp-service-web/';
const base = window.base;
//const base = '/education-jxcp-service-web/';

var modelArr = {};

const removeModelByKey = (key) => {
    delete modelArr[key];
}

const post = (url, params = {}, key) => fetch(base + url, {
    method: "POST",
    headers: Object.assign({}, headers, {
        'routeUrl': window.location.hash
    }),
    credentials: 'include',
    body: JSON.stringify(params)
})
    .then(response => response.json())
    .then(response => {
        return new Promise(function (resovle, reject) {
            if (response.code === 200) {
                if (response.payload.data && response.payload.data.pageSize) {
                    modelArr[key] = {
                        params,
                        response
                    };
                }

                resovle(response);
            } else if (response.code === 401) {
                if (window.sessionStorage.session) {
                    window.sessionStorage.clear();
                    window.location.hash = '/';
                    window.location.reload();
                }
            } else if (response.code === 412 || response.code === 60003) {
                //412状态码则是需要初始化密码 , 60003则重复登录了
                resovle(response);
            } else if (response.code === 419 || response.code === 420) {
                window.location.hash = '/license'
                window.location.reload();
            } else if (response.code === 60004) {
                //60004被其他用户挤下来了
                Modal.warn({
                    title: '提示',
                    content: '已被其他用户登录，点击前往登录页面',
                    onOk: () => {
                        post('employee/logout?').then((res) => {
                            if (res) {
                                sessionStorage.removeItem('session');
                                sessionStorage.removeItem('keywords');
                                if (res.payload.data) {
                                    const url = res.payload.data
                                    window.location.href = url
                                } else {
                                    window.location.hash = '/';
                                    window.location.reload();
                                }
                            } else {
                                Modal.error({
                                    title: '退出失败',
                                    content: '退出失败',
                                    okText: '确认'
                                })
                            }
                        })
                    }
                })
            } else {
                reject(response);
            }
        })
    }).catch(error => {
        if (/Unexpected|fetch/ig.test(error.message)) {
            if (errorCount === 0) {
                errorCount += 1;
                setTimeout(() => {
                    errorCount = 0;
                }, 1000)
            }
        } else {
            if (errorCount === 0) {
                Modal.error({
                    title: '错误提示',
                    content: (
                        <div>
                            <p>{error.message}</p>
                        </div>
                    ),
                    okText: "确认",
                    onOk: () => {
                        errorCount = 0;
                    },
                });

                errorCount += 1;
            }
        }
        return error;
    });


const get = url => fetch(base + url, {
    headers: Object.assign({}, headers, {
        'routeUrl': window.location.hash
    }),
    credentials: 'include',
})
    .then(response => response.json())
    .then(response => {
        return new Promise(function (resovle, reject) {
            if (response.code === 200) {
                resovle(response);
            } else if (response.code === 401) {
                if (window.sessionStorage.session) {
                    window.sessionStorage.clear();
                    window.location.reload();
                }
            } else if (response.code === 419 || response.code === 420) {
                window.location.hash = '/license'
                window.location.reload();
            } else if (response.code === 60004) {
                //60004被其他用户挤下来了
                Modal.warn({
                    title: '提示',
                    content: '已被其他用户登录，点击前往登录页面',
                    onOk: () => {
                        post('employee/logout?').then((res) => {
                            if (res) {
                                sessionStorage.removeItem('session');
                                sessionStorage.removeItem('keywords');
                                if (res.payload.data) {
                                    const url = res.payload.data
                                    window.location.href = url
                                } else {
                                    window.location.hash = '/';
                                    window.location.reload();
                                }
                            } else {
                                Modal.error({
                                    title: '退出失败',
                                    content: '退出失败',
                                    okText: '确认'
                                })
                            }
                        })
                    }
                })
            } else {
                reject(response);
            }
        })
    }).catch(error => {
        if (/Unexpected/.test(error.message)) {
            if (errorCount === 0) {
                Modal.error({
                    title: '错误提示',
                    content: (
                        <div>
                            <p>数据正在处理中，请稍候再试!!!</p>
                        </div>
                    ),
                    okText: "确认",
                    onOk: () => {
                        errorCount = 0;
                    },
                });

                errorCount += 1;
            }

        } else {
            if (errorCount === 0) {
                Modal.error({
                    title: '错误提示',
                    content: (
                        <div>

                            <p>{error.message}</p>

                        </div>
                    ),
                    okText: "确认",
                    onOk: () => {
                        errorCount = 0;
                    },
                });

                errorCount += 1;
            }
        }
        return error;
    })

const postProxy = (url, params = {}) => {
    let key = window.location.hash.replace('#', '');
    if (modelArr[key]) {
        let o1 = JSON.parse(JSON.stringify(modelArr[key].params));
        delete o1.v;
        let o2 = JSON.parse(JSON.stringify(params));
        delete o2.v;
        if (JSON.stringify(o1) === JSON.stringify(o2)) {
            return new Promise(function (resovle, reject) {
                resovle(modelArr[key].response);
            })
        } else {
            return post(url, params, key);
        }

    } else {
        return post(url, params, key);
    }
}

/**
 * post下载请求
 * @param {*} url 
 * @param {*} params 
 * @param {*} key 
 * @returns 
 */
const download = (url, params = {}, filenameParam) => fetch(base + url, {

    method: "POST",
    headers: headers,
    credentials: 'include',
    body: JSON.stringify(params)
})
    .then(function (response) {

        if (response.status === 200) {
            let filename = filenameParam || "下载文件.txt"

            response.blob().then(blob => {
                const link = document.createElement('a')
                link.style.display = 'none'
                // a 标签的 download 属性就是下载下来的文件名
                if (filename != null) {
                    link.download = filename
                }

                link.href = URL.createObjectURL(blob)
                document.body.appendChild(link)
                link.click()
                // 释放的 URL 对象以及移除 a 标签
                URL.revokeObjectURL(link.href)
                document.body.removeChild(link)
            });
        } else {
            Modal.error({
                title: '错误提示',
                content: (
                    <div>
                        <p>数据异常</p>
                    </div>
                ),
                okText: "确认",
                onOk: () => {
                    errorCount = 0;
                },
            });
        }


    });



export default {
    post,
    get,
    base,
    removeModelByKey,
    download
}
